module.exports = __webpack_public_path__ + "img/insurita-value-three-shape.a8546177.svg";